import React, { useState } from 'react';
import UserProfile from './UserProfile';
import SniperTab from './SniperTab';
import AlertsTab from './AlertsTab';
import { FiCrosshair, FiBell } from 'react-icons/fi';

const Dashboard = ({ user, token, onLogout, onThemeChange }) => {
  const [activeTab, setActiveTab] = useState('sniper');

  return (
    <div className="dashboard-container">
      <div className="sidebar">
        <div className="sidebar-logo">Q</div>
        <div className="sidebar-spacer"></div>
        <div
          className={`sidebar-icon ${activeTab === 'sniper' ? 'active' : ''}`}
          onClick={() => setActiveTab('sniper')}
          title="Sniper"
        >
          <FiCrosshair size={22} />
        </div>
        <div
          className={`sidebar-icon ${activeTab === 'alerts' ? 'active' : ''}`}
          onClick={() => setActiveTab('alerts')}
          title="Alerts"
        >
          <FiBell size={22} />
        </div>
        <UserProfile user={user} token={token} onLogout={onLogout} onThemeChange={onThemeChange} />
      </div>
      <div className="content-area">
        {activeTab === 'sniper' && <SniperTab user={user} token={token} />}
        {activeTab === 'alerts' && <AlertsTab user={user} />}
      </div>
    </div>
  );
};

export default Dashboard;
